import { supabase } from '@/integrations/supabase/client';

export interface Profile {
  id: string;
  email: string;
  full_name: string | null;
  role: 'admin' | 'client';
  avatar_url: string | null;
  created_at: string;
}

export interface Client {
  id: string;
  user_id: string | null;
  name: string;
  email: string;
  phone: string | null;
  plan: string;
  credit_score: number;
  starting_score: number;
  status: 'Active' | 'Paused' | 'Cancelled' | 'Completed';
  next_action: string | null;
  monthly_payment: number;
  notes: string | null;
  join_date: string;
  created_at: string;
}

export async function signIn(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  return { data, error };
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  return { error };
}

export async function getProfile(userId: string): Promise<Profile | null> {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();
  if (error) return null;
  return data as Profile;
}

export async function getAllClients(): Promise<Client[]> {
  const { data, error } = await supabase
    .from('clients')
    .select('*')
    .order('join_date', { ascending: false });
  if (error) return [];
  return data as Client[];
}

export async function updateClient(id: string, updates: Partial<Client>) {
  const { data, error } = await supabase
    .from('clients')
    .update(updates)
    .eq('id', id)
    .select()
    .single();
  return { data, error };
}

export async function addClient(client: Omit<Client, 'id' | 'created_at' | 'user_id'>) {
  const { data, error } = await supabase
    .from('clients')
    .insert(client)
    .select()
    .single();
  return { data, error };
}

export async function deleteClient(id: string) {
  const { error } = await supabase.from('clients').delete().eq('id', id);
  return { error };
}
